import bus from 'bus';
import dom from 'modules/env/dom';
import domains from 'modules/domains';
import templates from 'modules/templates';

export function create(container, templateNameCustom) {
    let loadingTemplatePromise,
        rendered;

    if (!templateNameCustom) {
        let node = container.find('script[type="text/html"]'),
            templateName = '_' + Math.round(Math.random() * 10000) + '-template';

        if (!node.length) {
            return;
        }

        node = node.eq(0);
        node.attr('id', templateName + '-template');

        loadingTemplatePromise = new Promise(resolve => {
            templates.get(templateName, domains.templates.intercept(tpl => {
                resolve(tpl);
            }));
        });

    } else {
        loadingTemplatePromise = new Promise(resolve => {
            templates.get(templateNameCustom, domains.templates.intercept(tpl => {
                resolve(tpl);
            }));
        });
    }

    loadingTemplatePromise.then(tpl => {
        bus.sync('command.view.change', model => {
            let updatedText = tpl.render(model);

            if (rendered !== updatedText) {
                rendered = updatedText;
                dom.contents(container, rendered);
            }

        });
    });
}

